const items = {
  "nut.users.sign-in.title": "sign in",
  "nut.users.sign-up.title": "sign up",
  "nut.users.sign-in-up.title": "sign in/sign up",
  "nut.users.logs.title": "logs",
  "nut.users.forgot-password.title": "forgot password",
};

export default items;
